import React, { useEffect } from "react";

import { withReportCar } from "../../shared/containers/containerReportCar";
import { withReport } from "../../shared/containers/containerReport";
import { withReportData } from "../../shared/containers/containerReportData";
import { withUnitReport } from "../../shared/containers/containerUnitReport";
import { withSelectedCars } from "../../shared/containers/containerSelectedCars";
import { withSelectedReports } from "../../shared/containers/containerSelectedReports";

import ButtonPrimary from "../../shared/items/contols/buttonPrimary";
import { states } from "../../reducers/queriesStates";

const getReportData = (props) => {
  const { startDate, endDate, reportId, selectedReports, selectedCars, cancelUnitReport, onGetUnitsReport } = props;

  const options = {
    units: selectedCars.map((x) => {
      return x.id;
    }),
    startDate: startDate,
    endDate: endDate,
    timeZone: new Date().getTimezoneOffset() / -60,
  };

  onGetUnitsReport(reportId, options, cancelUnitReport.token, selectedReports[0]);
};

const ReportTimeRangeButtonWrapper = (props) => {
  const { reportId, reportCarId, onSetReportParamsReady, onSetReportParamsNotReady, unitReportDataState } = props;
  const isButtonDisabled = unitReportDataState === states.REQUEST || !reportId || !reportCarId;

  useEffect(() => {
    onSetReportParamsNotReady();

    return () => {
      onSetReportParamsReady();
    };
  }, []);

  return <ButtonPrimary handleClick={getReportData.bind(this, props)} title="Показать на странице" disabled={isButtonDisabled} />;
};

export default withSelectedReports(
  withUnitReport(withSelectedCars(withReportData(withReportCar(withReport(React.memo(ReportTimeRangeButtonWrapper))))))
);
